var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
export var RandomStringGenerator = {
  alphanum: function alphanum(length) {
    return possible.split("").map(function () {
      return possible.charAt(Math.floor(possible.length * Math.random()));
    }).join("").substring(0, length);
  }
};